module.exports = __webpack_public_path__ + "static/media/allergysymptoms-1_m.77447dd4.jpg";